import { ModalService } from './../../../../../services/modal.service';
import { AlertService } from './../../../../../services/alert.service';
import { IpPublicService } from './../../../../../services/ip-public.service';
import { DesempenioProcesoService } from './../../../services/desempenio-proceso.service';
import { DesempenioProceso } from './../../../models/desempenioProceso';
import { Component, OnDestroy, OnInit, ViewChild, Input } from '@angular/core';
import { ProcesoService } from './../../../services/proceso.service';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map } from 'rxjs';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { EspecialUnoService } from 'src/app/modulos/catalogos-proces/services/especial-uno.service';
@Component({
  selector: 'app-desempenio-proceso',
  templateUrl: './desempenio-proceso.component.html',
  styleUrls: ['./desempenio-proceso.component.css'],
})
export class DesempenioProcesoComponent implements OnInit, OnDestroy {
  public formDesempenioProceso!: UntypedFormGroup;
  public formSubmitted = false;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public dataDesempenioProceso: any[] = [];
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public modalCreaDesempenioProceso: string = 'modalCreaDesempenioProcesos';
  public nombreUnidad!: any;
  public dataProcesos: any[];
  public importanciaSeleccionada: any = [];
  public desempenioSeleccionado: any = [];
  public calificaciones!: any;
  public calificacionesEdit!: any;
  public importanciaEdit!: any;
  public desempenioEdit!: any;
  public pesoRestante: number = 100;
  public pesoEdit: any = 0;
  public pesoTotalEditado: any = 0;
  public peso: any;
  public desahabilitarForm: boolean = false;
  public dataCaracteristicas!: any;
  public dataImportancia!: any;
  public dataNombreImportancia!: any;
  public dataDesempenio!: any;
  public idSprAmbiente!: number;
  public idSprProceso: number = 0;
  public idSprNivel: number = 0;
  public guardarCalificaciones = 0;
  editPorcentajeTotal: boolean = true;
  editPorcentaje: boolean = false;
  nameApp = 'DESEMPEÑO';

  public idSprComunCaracteristicas = ConstantsCatalogosIdService.ID_COMUNES_CARACTERISTICA_PROCESO;
  public idSprEspecialUnoImportancia = ConstantsCatalogosIdService.ID_ESPECIAL_IMPORTANCIA_PROCESO;
  public idSprEspecialUnoDesempenio = ConstantsCatalogosIdService.ID_ESPECIAL_DESEMPENIO_PROCESO;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  @Input() set init(desempenioObj: any) {
    this.dataNombreImportancia = null;
    if (desempenioObj != null) {
      this.idSprProceso = desempenioObj.idSprProceso;
      //this.nameApp = desempenioObj.nombre;
      this.initApp();
    } else {
      this.idSprProceso = 0;
      this.dataNombreImportancia = null;
    }
  }
  readonly constant = ConstantsCatalogosIdService;

  constructor(
    private fb: FormBuilder,
    private ProcesoService: ProcesoService,
    private desempenioProcesoService: DesempenioProcesoService,
    private comunService: ComunService,
    private especialUnoService: EspecialUnoService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private store: Store<AppState>
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.nombreUnidad = this.currentUser.nombreUnidad;
    //
    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.store.select('globalApp').subscribe((response) => {
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
    });
  }

  get DesempenioProcesoForm() {
    return this.formDesempenioProceso.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  habilitarForm() {
    this.desahabilitarForm = true;
  }

  setForm() {
    this.formDesempenioProceso = this.fb.group({
      idSprDesempenioProceso: [],
      idSprProceso: [this.idSprProceso],
      idSprDesempenio: ['', [Validators.required]],
      idSprCaracteristica: ['', [Validators.required]],
      idSprImportancia: ['', [Validators.required]],
      peso: ['', [Validators.required]],
      calificacion: ['', [Validators.required]],
      //  accionTomar: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
  }

  initApp() {
      this.calificaciones = '';
      this.listDesempenioProceso(this.idSprProceso);
      this.getAllData(this.idSprAmbiente, this.idSprProceso);
      this.setDataTable();
      this.setForm();
  }

  ngOnInit(): void {
    this.getIpPublic();
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  getAllData(idSprAmbiente: number, idSprProceso: number) {
    if (idSprProceso == undefined) {
      return;
    }
    forkJoin([
      this.ProcesoService.list('?idSprAmbiente=' + idSprAmbiente),
      this.desempenioProcesoService.list('?idSprProceso=' + idSprProceso),
      this.comunService.list('?spr_idSprComun=' + this.idSprComunCaracteristicas),
      this.especialUnoService.list('?spr_idSprEspecialUno=' + this.idSprEspecialUnoDesempenio),
      this.especialUnoService.list('?spr_idSprEspecialUno=' + this.idSprEspecialUnoImportancia),
    ])
      .pipe(
        map(
          ([
            procesos,
            desempenioProcesos,
            caracteristicas,
            desempenio,
            importancia,
          ]) => {
            this.dataProcesos = procesos;
            this.dataDesempenioProceso = desempenioProcesos;
            this.dataCaracteristicas = caracteristicas;
            this.dataDesempenio = desempenio;
            this.dataImportancia = importancia;
            //this.calculo1(this.dataDesempenioProceso, this.pesoRestante);
            this.mapeoImportancia();
          }
        )
      )
      .subscribe();
  }

  listDesempenioProceso(idSprProceso: any) {
    if (idSprProceso) {
      this.desempenioProcesoService.list('?idSprProceso=' + idSprProceso).subscribe((resp) => {
        this.dataDesempenioProceso = resp;
        this.calculo1(this.dataDesempenioProceso, this.pesoRestante); // envia parametros para realizar el cálculo
        //this.reDrawDataTable();
      });
    }
  }

  mapeoImportancia() {
    this.dataNombreImportancia = [];
    let dataProcess = [];

    for (let i = 0; i < this.dataDesempenioProceso.length; i++) {
      for (let j = 0; j < this.dataImportancia.length; j++)
        for (let k = 0; k < this.dataCaracteristicas.length; k++)
          for (let l = 0; l < this.dataDesempenio.length; l++) {
            if (this.dataImportancia[j].idSprEspecialUno === this.dataDesempenioProceso[i].idSprImportancia)
              if (this.dataCaracteristicas[k].idSprComun === this.dataDesempenioProceso[i].idSprCaracteristica)
                if (this.dataDesempenio[l].idSprEspecialUno === this.dataDesempenioProceso[i].idSprDesempenio) {
                  dataProcess.push({
                    idSprDesempenioProceso: this.dataDesempenioProceso[i].idSprDesempenioProceso,
                    nombreImportancia: this.dataImportancia[j].nombre,
                    nombreCaracteristica: this.dataCaracteristicas[k].nombre,
                    idSprCaracteristica: this.dataDesempenioProceso[i].idSprCaracteristica,
                    idSprImportancia: this.dataDesempenioProceso[i].idSprImportancia,
                    nombreDesempenio: this.dataDesempenio[l].nombre,
                    idSprDesempenio: this.dataDesempenioProceso[i].idSprDesempenio,
                    peso: this.dataDesempenioProceso[i].peso,
                    calificacion: this.dataDesempenioProceso[i].calificacion,
                    //     accionTomar: this.dataDesempenioProceso[i].accionTomar,
                    estado: this.dataDesempenioProceso[i].estado,
                  });
                }
          }
    }
    this.dataNombreImportancia = dataProcess;
    //this.reDrawDataTable();
  }

  reDrawDataTable() {
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onSelectImportancia(importancias: any[]) {
    if (importancias != null) {
      this.especialUnoService.list(`${importancias}` ).subscribe(resp => {
        this.importanciaSeleccionada = resp
        this.calculoCalificacion();
      })
    }
  }

  onSelectDesempenio(desempenios: any[]) {
    if (desempenios != null) {
      this.especialUnoService.list(`${desempenios}` ).subscribe(resp => {
        this.desempenioSeleccionado = resp
        this.calculoCalificacion();
      })
    }
  }

  calculoCalificacion() {
    this.calificaciones = this.desempenioSeleccionado.ponderacion * this.importanciaSeleccionada.ponderacion;
  }


  validacionPeso(peso: any, pesoRestante: any, pesoTotalEdit: any) {
    if (this.formDesempenioProceso.value.idSprDesempenioProceso == null) {
      if (peso > pesoRestante) {
        this.alert.warning(
          '¡Atención!',
          'Peso seleccionado debe ser menor o igual que: ' + pesoRestante + '%'
        );
      } else if (peso == 0) {
        this.alert.warning('¡Atención!', 'Peso seleccionado no puede ser 0% ');
      }
    } else {
      if (peso > pesoTotalEdit) {
        this.alert.warning(
          '¡Atención!',
          'Peso seleccionado debe ser menor o igual que: ' + pesoTotalEdit + '%'
        );
      } else if (peso == 0) {
        this.alert.warning('¡Atención!', 'Peso seleccionado no puede ser 0% ');
      }
    }
  }
  //crear
  onSubmit() {
    this.formSubmitted = true;
    this.formDesempenioProceso.value.usuario = this.currentUser.idSprUsuario;
    this.formDesempenioProceso.value.ip = this.ipAddress;
    this.formDesempenioProceso.value.idSprProceso = this.idSprProceso;
    let peso = this.formDesempenioProceso.value.peso;
    let pesoTotalEdit = this.pesoTotalEditado;
    let pesoRestante = this.pesoRestante;
    //this.validacionFechas(fechaComprometida, FechaCumplimiento);
    this.validacionPeso(peso, pesoRestante, pesoTotalEdit);
    //if (this.formDesempenioProceso.valid) {
    if (this.formDesempenioProceso.value.idSprDesempenioProceso == null && peso <= pesoRestante && peso != 0) {
      this.formDesempenioProceso.value.calificacion = this.calificaciones;
      if (this.listCatalogoExiste(this.formDesempenioProceso.value.idSprCaracteristica))//para que no repita el mismo nombre

        this.desempenioProcesoService.create(this.formDesempenioProceso.value)
          .subscribe(
            (resp) => {
              this.initApp();
              this.closeModalDesempenio();
              this.alert.createOk();
              this.editPorcentajeTotal = true;
              this.editPorcentaje = false;
            },
            (err) => {
              this.alert.createError();
            }
          );
    } else if (peso <= pesoTotalEdit && peso != 0) {
      this.formDesempenioProceso.value.calificacion = this.calificaciones;
      this.desempenioProcesoService.update(this.formDesempenioProceso.value).subscribe({
        next: (resp) => {
          this.closeModalDesempenio();
          this.alert.updateOk();
          this.initApp();
        },
        error: (err) => {
          this.alert.updateError();
        },
      });
      ///});
      //});
      /*FIUN */

      //}
      //return true;
      //} else {
      //return false;
    }
  }

  edit(obj: DesempenioProceso) {
    this.editPorcentajeTotal = false;
    this.editPorcentaje = true;
    this.openModalDesempenio();
    this.guardarCalificaciones = obj.calificacion;
    this.formDesempenioProceso.patchValue({
      idSprDesempenioProceso: obj.idSprDesempenioProceso,
      idSprProceso: obj.idSprProceso,
      idSprDesempenio: obj.idSprDesempenio,
      idSprCaracteristica: obj.idSprCaracteristica,
      idSprImportancia: obj.idSprImportancia,
      peso: obj.peso,
      calificacion: obj.calificacion,
      //   accionTomar: obj.accionTomar,
      estado: obj.estado,
    });
    this.pesoEdit = obj.peso;
    this.pesoTotalEditado = this.pesoRestante + this.pesoEdit;
  }

  ////////////////VALIDACIÓN DE NO CREAR LA MISMA CARACTERISTICA/////////////////

  listCatalogoExiste(idSprCaracteristica: number) {
    for (let elemento of this.dataDesempenioProceso) {
      if (elemento.idSprCaracteristica == idSprCaracteristica) {
        this.alert.warning(
          '¡Atención!',
          'Existe una característica con el mismo nombre.'
        );
        return false;
      }
    }
    return true;
  }

  delete(idRegister: number) {
    this.modal.open('delete-desempenio');
    this.idDeleteRegister = idRegister;
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.desempenioProcesoService
        .delete({
          idSprDesempenioProceso: this.idDeleteRegister,
          usuario: this.currentUser.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.closeId('delete-desempenio');
            this.alert.deleteOk();
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    }
  }

  calculo1(dataActividades: any, pesoRestante: number) {
    let ponderacionTotalActividad: any = 100;
    let pesoAterior: any = 0;
    let pesoActual: any;
    let ponderacionRestante: any = 100;
    for (let i = 0; i < dataActividades.length; i++) {
      pesoActual = dataActividades[i].peso;
      pesoAterior = pesoActual + pesoAterior;
      ponderacionRestante = ponderacionTotalActividad - pesoAterior;
    }
    this.pesoRestante = ponderacionRestante;
    this.pesoTotalEditado = this.pesoRestante + this.pesoEdit;
  }
  openModalDesempenio() {
    this.onResetForm();
    this.modal.open(this.modalCreaDesempenioProceso);
  }

  onResetForm() {
    this.formSubmitted = false;
    this.formDesempenioProceso.reset();
  }

  closeModalDesempenio() {
    this.modal.closeId(this.modalCreaDesempenioProceso);
    this.editPorcentajeTotal = true;
    this.editPorcentaje = false;
  }
}
